// removed by extract-text-webpack-plugin
module.exports = {"root":"CentricUI__components__ConfirmationDialog__root","paper":"CentricUI__components__ConfirmationDialog__paper","actions":"CentricUI__components__ConfirmationDialog__actions","buttonText":"CentricUI__components__ConfirmationDialog__buttonText","editButton":"CentricUI__components__ConfirmationDialog__editButton","dialogContent":"CentricUI__components__ConfirmationDialog__dialogContent"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/components/ConfirmationDialog.css
// module id = 558
// module chunks = 10